import { createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
export default createTheme({
    palette: palette,
    typography: typography,
});
//# sourceMappingURL=baseTheme.js.map